import Vue from 'vue';
import auth from '@/auth/Auth0';
import PortalVue from 'portal-vue';
import VCalendar from 'v-calendar';
import VueScrollTo from 'vue-scrollto';
import VTooltip from 'v-tooltip';

Vue.use(auth);
Vue.use(PortalVue);
Vue.use(VCalendar);
Vue.use(VueScrollTo);
Vue.use(VTooltip, {
    disposeTimeout: 100,
    popover: {
        defaultClass: 'c-popover',
        defaultBaseClass: '',
        defaultWrapperClass: 'c-popover__wrapper',
        defaultInnerClass: 'c-popover__inner',
        defaultArrowClass: 'c-popover__arrow'
    }
});
